// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3piaE","content":"LoadingAlert_content__gq_AR"};